export enum ScriptType {
  Defer = 'Defer',
  Async = 'Async',
}

export interface Script {
  name?: string;
  attribute?: string;
  source?: string;
}
